export class StatefulError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}
